import {
  Button,
  Modal,
  ModalContent,
  ModalTrigger,
  Icon,
} from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { useAgentAuthDetails } from '@repo/services'
import { ShebaInput } from '@/layouts'
import { KycBlocker } from '@repo/shared'

export const WithdrawOnlinePaymentAddCard = () => {
  const { t } = useTranslate()
  const { data: authDetails } = useAgentAuthDetails()
  const hasKyc =
    authDetails?.data.details?.kyc &&
    authDetails?.data.details?.kyc?.status === 'approved'

  return (
    <Modal>
      <ModalTrigger asChild>
        <Button
          type='button'
          color='base'
          variant='transparent'
          size='sm'
          startIcon={<Icon name='PlusLine' size='sm' />}
        >
          {t('withdrawOnlinePaymentPage_add_card')}
        </Button>
      </ModalTrigger>
      <ModalContent className='sm:max-w-[425px]'>
        {hasKyc ? (
          <ShebaInput />
        ) : (
          <KycBlocker
            phone={authDetails?.data.phone}
            email={authDetails?.data.email}
            kyc={authDetails?.data.details?.kyc}
          />
        )}
      </ModalContent>
    </Modal>
  )
}
